import React from 'react';
import { DataWrapperSm, HeaderWrapperSm, LabelSm } from './kpi-styles';

/**
 * Wrapper for small card kpi headers
 *
 * @param {string} props.label
 * @param {func} props.onPin
 */
export function HeaderSm(props) {
  const { noData, labelFontSize, label, marginUnderLabel } = props;
  return (
    <HeaderWrapperSm>
      <LabelSm marginUnderLabel={marginUnderLabel} fontSize={labelFontSize}>
        {label}
      </LabelSm>
      {!noData && <DataWrapperSm>{props.children}</DataWrapperSm>}
    </HeaderWrapperSm>
  );
}
